import { render, staticRenderFns } from "./uv-index.vue?vue&type=template&id=3ad66b71&"
import script from "./uv-index.vue?vue&type=script&lang=js&"
export * from "./uv-index.vue?vue&type=script&lang=js&"
import style0 from "./uv-index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports